import React, { FC, ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import './Header.css';

interface HeaderProps {
  status?: ReactNode;
}

const Header: FC<HeaderProps> = ({ status }) => {
  const navigate = useNavigate();

  return (
    <header className="app-header">
      <div className="header-main">
        <div className="header-inner">
          <div className="header-title">BB Manager</div>
          <button className="header-menu" onClick={() => navigate('/')} title="Back to Home">
            <span/><span/><span/>
          </button>
        </div>
    </div>
    <div className="header-status">
      <div className="header-status-inner">{status}</div>
    </div>
    </header>
  );
};

export default Header;
